<template>
  <div id="server_view">
    <div class="headline">
      <div class="describe">{{$t('service.SERVICE_DESCRIPTION')}}</div>
      <div class="title">{{$t('service.SERVICE_TITLE')}}</div>
    </div>
    <div class="navbar">
      <span @click="onToggle(0)">{{$t('service.LIQUID_COOLING_SERVICE')}}</span>
      <div class="line"></div>
      <span @click="onToggle(1)">{{$t('service.AIGC_INFRASTRUCTURE')}}</span>
    </div>
    <div class="swiper">
      <div 
        class="swiper_content" 
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
        :style="{'transform': `translateX(${translateX})`, 
        'max-height': maxHeight
        }"
        ref="serviceRef"
      >
        <InfrastructureView/>
        <LiquidCooling @height="height"/>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import InfrastructureView from "./pages/InfrastructureView.vue";
import LiquidCooling from "./pages/LiquidCooling.vue";
import { onMounted, ref, onUnmounted, onActivated, computed, nextTick } from 'vue'
import useSwiper from '@/utils/useSwiper'
import Mitt from "@/utils/mitt";
import routerHash from "@/constant/router_hash";

const MAX_INDEX = 1
const unit = 50 

const serviceRef = ref<HTMLDivElement | null>(null)
const RightHeight = ref(0)

const maxHeight = computed(() => currentIndex.value === 0 ? 'none' : `calc(6rem + ${RightHeight.value}px)`)

const { translateX, currentIndex, onTouchStart, onTouchMove, onTouchEnd } = useSwiper(unit, MAX_INDEX)

const onToggle = (index:number) => currentIndex.value = index

const height = (vHeight: number) => RightHeight.value = vHeight

onMounted(() => {
  Mitt.on(routerHash.IDC_LIQUID_COOLING, () => {
    serviceRef.value!.scrollIntoView(true)
    onToggle(0)
  })
    Mitt.on(routerHash.AIGC_INFRASTRUCTURE, () => {
    serviceRef.value!.scrollIntoView(true)
    onToggle(1)
  })
})

onUnmounted(() => {
  Mitt.off(routerHash.IDC_LIQUID_COOLING)
  Mitt.off(routerHash.AIGC_INFRASTRUCTURE)
})

onActivated(() => window.scrollTo({ top: 0 }))
</script>

<style scoped lang="less">
#server_view {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  min-height: 100vh;
  animation: fadeIn 1s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .headline {
    width: 100%;
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30rem;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('@/assets/service/service_thumbnail.png');
    background-size: cover;
    
    .title {
      max-width: var(--view-max-width);
      font-size: var(--primary-title);
      margin-bottom: 1rem;
      overflow: hidden;
      text-align: center;
      margin-top: 0.75rem;
      line-height: 3.8rem;
      color: #fff;
      animation:  fadeIn 1s 0.5s forwards;
      opacity: 0;
      font-weight: 700;
      font-family: "HarmonyOS_Bold";
    }

    .describe {
      font-size: var(--primary-text);
      color: #fff;
      animation:  fadeIn 1s 0.5s forwards;
      opacity: 0;
    }
  }

  .navbar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    height: 34px;
    font-size: 1.2rem;

    .line {
      height: 100%;
      width: 2px;
      background: #000;
    }

    span {
      cursor: pointer;
      height: 100%;
      line-height: 32px;
      white-space: nowrap;
      text-overflow: ellipsis;

      &:hover {
        border-bottom: 2px solid #002FA5;
        color: #002FA5;
      }
    }
  }

  .swiper {
    width: 100%;
    overflow-x: hidden;

    &_content {
      display: flex;
      width: 200%;
      transition: all 0.5s;
      overflow-y: hidden;
    }
  }
}
</style>